import { put, call } from 'redux-saga/effects';
import * as API from '../../services/api';
import actionTypes from '../actionTypes';

export function* getDealUsers({ dealId }) {
  try {
    const dealUsers = yield call(API.getDealUsers, dealId);
    yield put({ type: actionTypes.DEAL_USERS_GET_SUCCESS, dealUsers });
  } catch (error) {
    yield put({ type: actionTypes.DEAL_USERS_GET_ERROR, error });
  }
}

export function* getDealUser({ dealUser }) {
  try {
    const result = yield call(API.getDealUser, dealUser);
    if (result.id) {
      yield put({ type: actionTypes.DEAL_USER_GET_SUCCESS, dealUser: result });
    } else {
      yield put({ type: actionTypes.DEAL_USER_GET_ERROR });
    }
  } catch (error) {
    yield put({ type: actionTypes.DEAL_USER_GET_ERROR, error });
  }
}

export function* createDealUser({ dealUser }) {
  try {
    const result = yield call(API.createDealUser, dealUser);
    if (result.error) {
      yield put({
        type: actionTypes.DEAL_USER_CREATE_ERROR,
        error: result.error,
      });
    } else {
      yield put({
        type: actionTypes.DEAL_USER_CREATE_SUCCESS,
        dealUser: result,
      });
    }
  } catch (error) {
    yield put({ type: actionTypes.DEAL_USER_CREATE_ERROR, error });
  }
}

export function* updateDealUser({ dealUser }) {
  try {
    const result = yield call(API.updateDealUser, dealUser);
    if (result.id) {
      yield put({
        type: actionTypes.DEAL_USER_UPDATE_SUCCESS,
        dealUser: result,
      });
    } else {
      yield put({ type: actionTypes.DEAL_USER_UPDATE_ERROR });
    }
  } catch (error) {
    yield put({ type: actionTypes.DEAL_USER_UPDATE_ERROR, error });
  }
}

export function* deleteDealUser({ dealUser }) {
  try {
    yield call(API.deleteDealUser, dealUser);
    yield put({
      type: actionTypes.DEAL_USER_DELETE_SUCCESS,
      dealUserId: dealUser.id,
    });
  } catch (error) {
    yield put({ type: actionTypes.DEAL_USER_DELETE_ERROR, error });
  }
}



// WEBPACK FOOTER //
// src/redux/sagas/dealUsers.js